module.exports = {
    ADV_TYPE_ALL: 'all',
    ADV_TYPE_DEFAULT: 'default',
};
